/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_Analyse_ErrorInputs */

const en_upload_analyse_error = /** @type {(inputs: Upload_Analyse_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic analysis could not be completed. You can continue and review the case manually.`)
};

const pt_br2_upload_analyse_error = /** @type {(inputs: Upload_Analyse_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível concluir a análise automática. Você pode continuar e revisar o caso manualmente.`)
};

/**
* | output |
* | --- |
* | "Automatic analysis could not be completed. You can continue and review the case manually." |
*
* @param {Upload_Analyse_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const upload_analyse_error = /** @type {((inputs?: Upload_Analyse_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_Analyse_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upload_analyse_error(inputs)
	return pt_br2_upload_analyse_error(inputs)
});